import SettingButtons from "components/shared/SettingButtons";
import { resolveCountryLanguage } from "helpers/countryLanguage";
import { useTranslation } from "react-i18next";
import type { SettingsState } from "store/settingsStore";
import { setLocalSettings } from "store/settingsStore";
import { useAppDispatch, useAppSelector } from "store/store";

const BPProfile = () => {
    const [t, i18n] = useTranslation();
    const dispatch = useAppDispatch();

    const { accountSettings } = useAppSelector((state) => state.settings);
    const companyCountryCode = useAppSelector((state) => state.beneficiary.beneficiarCompagnies[0]?.countryCode);

    const handleChangeButton = (name: string, value) => {
        i18n.changeLanguage(resolveCountryLanguage(companyCountryCode, value));
        dispatch(setLocalSettings({ accountSettings: { language: value, languageSetByUser: true } } as SettingsState)); // We should be passing whole settings state but currently this dispatch is only used for accountSettins :)
    };
    return (
        <SettingButtons
            name="language"
            title={t("Settings.AccountLanguage")}
            description={t("Settings.ChooseLanguage")}
            setSetting={handleChangeButton}
            value={accountSettings.language}
            options={["fr", "en"]}
        />
    );
};

export default BPProfile;
